import * as net from "../vipa/net";

export class Case {
    constructor() {
        $("#variant-section").on("click", ".product-favourite-button", this.#click.bind(this));
        $("#favourites").on("click", ".product-favourite-button", this.#click.bind(this));
    }

    #click(event: JQuery.ClickEvent) {
        let product_id = $(event.currentTarget).data("id");
        let data = {
            jsonrpc: "2.0",
            id: null,
            product_id: product_id,
        }
        let url;
        if (globalThis.lang) {
            url = `/${globalThis.lang}/j/toggle-product-favourite/`;
        } else {
            url = "/j/toggle-product-favourite/";
        }

        $(`#product-favourite-icon-${product_id}`)
            .removeClass()
            .addClass("gray fas fa-sync-alt fa-spin fa-lg");

        net.postJSON(url, data,
            (response: any) => {
                this.#doCompleted(response, product_id)
            })
            .fail((response: any) => {
                this.#showError(response, product_id)
            });
    }

    #doCompleted(response: JQuery.PlainObject, product_id: string): void {
        let classes = "gray far fa-star fa-lg";
        if (response.result.is_added) {
            classes = "yellow fa fa-star fa-lg";
            window.sa_event('click_add_favourite', {'variant': product_id});
        } else {
            window.sa_event('click_remove_favourite', {'variant': product_id});
        }
        $(`#product-favourite-icon-${product_id}`)
            .removeClass()
            .addClass(classes);
    }

    #showError(response: JQuery.jqXHR, product_id: string): void {
        $(`#product-favourite-icon-${product_id}`)
            .removeClass()
            .addClass("red fas fa-exclamation-triangle fa-lg");
    }
}
